import { render, staticRenderFns } from "./IconSvgAFPM1.vue?vue&type=template&id=18eb1d4e&scoped=true&"
import script from "./IconSvgAFPM1.vue?vue&type=script&lang=js&"
export * from "./IconSvgAFPM1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18eb1d4e",
  null
  
)

export default component.exports